import "@/App.css";
import { Toaster } from "sonner";
import SarvagunaApp from "./sarvaguna/SarvagunaApp";

function App() {
  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <SarvagunaApp />
    </div>
  );
}

export default App;
